import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import PlaceholderImg from "../../assets/image/placeholder/placeholder.jpg";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import {
  fontSize_headerTitles,
  fontSize_headings,
  maxWidth,
} from "../../shared/styleconfig";
import Supabase from "../../backend/client";
import { errorToaster } from "../../util/toaster";
import moment from "moment";
import MaskLoader from "../../components/MaskLoader";
import NewsView from "../../components/NewsView";
import { BLOG_CATEGORY } from "../../shared/constant";

const Blog = () => {
  const [loader, setLoader] = useState(false);
  const [allNews, setAllNews] = useState([]);
  const [currentNews, setCurrentNews] = useState([]);
  const [open, setOpen] = useState(false);
  const [readItem, setReadItem] = useState(null);
  const [searchedNews, setSearchedNews] = useState([]);
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "TRADEFOLIO - Learn";
  }, []);

  const getBlogs = async () => {
    setLoader(true);
    let { data: blogs, error } = await Supabase.from("blogs")
      .select("*")
      .order("id", { ascending: false });
    if (error) {
      errorToaster("Something went wrong.");
      return;
    }
    console.log("allblogs", blogs);
    const allblogs = [...blogs];
    setAllNews(blogs);
    setCurrentNews(allblogs?.splice(0, 9));
    setLoader(false);
  };

  useEffect(() => {
    getBlogs();
  }, []);

  const handleLoadMore = () => {
    if (allNews?.length > currentNews?.length) {
      const newIndex = currentNews?.length + 3;
      if (newIndex < allNews?.length) {
        const newsArr = [...allNews];
        const arr = newsArr?.splice(0, newIndex);
        setCurrentNews(arr);
      } else {
        setCurrentNews(allNews);
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleReadmore = (item) => {
    setReadItem(item);
    setOpen(true);
  };

  const handleSearch = (e) => {
    const text = e?.target?.value;
    const name = e?.target?.name;
    if (name === "category" && text?.length) {
      const filtered = allNews?.filter((item) => item?.category === text);
      if (!filtered?.length) {
        setNoData(true);
      } else {
        setNoData(false);
      }
      setSearchedNews(filtered);
    } else if (text?.length) {
      const filtered = allNews?.filter((item) =>
        item?.title?.toLowerCase()?.includes(text?.toLowerCase())
      );
      if (!filtered?.length) {
        setNoData(true);
      } else {
        setNoData(false);
      }
      setSearchedNews(filtered);
    } else {
      setNoData(false);
      setSearchedNews([]);
    }
  };

  const newsFiltered = searchedNews?.length ? searchedNews : currentNews;

  return loader ? (
    <MaskLoader />
  ) : (
    <div className="w-full font-[Helvetica LT Std]">
      {/* Head */}
      <div className="pt-[116px] bg-[#001639] flex justify-center">
        <div
          className={` bg-[#0061FC] p-4 rounded-t-[20px] w-[90%] ${maxWidth}`}>
          {/* subTitle */}
          <p
            className={`text-[#76ABFF] font-semibold ${fontSize_headerTitles}`}>
            Learn
          </p>
          {/* Title */}
          <p className={`text-[#FFFFFF] font-semibold ${fontSize_headings}`}>
            Learning Center
          </p>
        </div>
      </div>
      <div className="flex justify-center">
        <div className={`flex flex-col justify-center  w-[90%] ${maxWidth}`}>
          <div className="p-10 flex xs:flex-col sm:flex-col lg:flex-row items-center">
            <p className="font-extrabold text-[25px] sm:flex-1 md:flex-1 lg:flex-[0.5]">
              Latest Articles
            </p>
            <div className="xs:flex-1 sm:flex-1 lg:flex-[0.5] flex ">
              <TextField
                name="search"
                placeholder="Search"
                type="search"
                fullWidth
                className="flex-[.7]"
                onChange={handleSearch}
              />
              &nbsp;
              {/* <Autocomplete
                                fullWidth
                                className='flex-[.3]'
                                disablePortal
                                options={BLOG_CATEGORY}
                                getOptionLabel={option => option?.label}
                                sx={{}}
                                renderInput={(params) => <TextField {...params} label="Filter"/>}
                                onChange={handleSearch}
                            /> */}
              <select
                className="flex-[.3] border-solid border-[1px] rounded-md"
                onChange={handleSearch}
                name="category">
                <option value="">All</option>
                {BLOG_CATEGORY?.map((item, i) => (
                  <option key={i} value={item?.label}>
                    {item?.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="px-5 grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {/* New grids */}
            {!noData
              ? newsFiltered?.map((item, i) => {
                  return (
                    <div key={i} className="h-300 bg-[#F2F2F2] rounded-[20px]">
                      <img
                        src={item?.cover}
                        alt="image"
                        className={`h-[300px] 3xl:h-[300px] md:h-[200px] w-[100%] rounded-t-[20px] object-cover grayscale hover:grayscale-0`}
                      />
                      <div className="p-5">
                        <p className="text-[10px] font-bold text-[#000000] ">
                          {moment(item?.published_at)?.format("DD MMMM, YYYY")}
                        </p>
                        <p className="text-[14px] font-semibold font-sans ">
                          {item?.title}
                        </p>
                        <div className="pt-2 flex place-content-between items-center">
                          <p className="text-[10px] font-bold text-[#000000] opacity-40">
                            {item?.author}
                          </p>
                          <p
                            className="text-[10px] font-bold cursor-pointer"
                            onClick={() => handleReadmore(item)}>
                            READ MORE{" "}
                            <ArrowRightAltIcon className="text-[18px]" />
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })
              : ""}
          </div>

          {noData ? (
            <div className="text-center text-slate-600">No Data Found</div>
          ) : (
            ""
          )}

          <div className="flex place-content-around p-12">
            {allNews?.length === currentNews?.length ? (
              ""
            ) : (
              <button
                className="py-5 px-10 border-[#B9B9B9] border-2 rounded-full text-[#B9B9B9] font-bold"
                onClick={handleLoadMore}>
                Load More
              </button>
            )}
          </div>
        </div>
      </div>

      {open ? (
        <NewsView open={open} handleClose={handleClose} blogData={readItem} />
      ) : (
        ""
      )}
    </div>
  );
};

export default Blog;
